import {Component} from '@angular/core';
import {filter, Subscription as RxSubscription} from 'rxjs';
import {AuthService} from '../services/auth.service';
import {NavigationEnd, NavigationStart, Router} from '@angular/router';

@Component({
    selector: 'app',
    templateUrl: './app.component.html',
    styleUrl: 'app.component.scss',
    standalone: false
})
export class AppComponent {
  public isLoggedIn: string | boolean | null = true;
  public isCheckoutRoute = false;
  private Subscriptions: RxSubscription[] = [];

  constructor(public authService: AuthService, private router: Router) {}

  ngOnInit() {
    this.setCheckoutRoute(this.router.url);
    this.Subscriptions.push(
      this.authService.isAuthenticated.subscribe(authenticated => {
        this.isLoggedIn = authenticated;
      }),
      this.router.events
        .pipe(filter(event => event instanceof NavigationEnd))
        .subscribe((event: NavigationEnd) => {
          this.setCheckoutRoute(event.urlAfterRedirects);
        })
    );
  }

  private setCheckoutRoute(url: string): void {
    this.isCheckoutRoute = url.split(/[?#]/)[0] === '/checkout';
  }
}